import * as angular from 'angular';
import { AbsentStudentsListComponent } from './absent-students-list.component';

export const AbsentStudentsListModule = angular
  .module('absentStudentsList', [])
  .component('absentStudentsList', AbsentStudentsListComponent).name;
